module.exports = __webpack_public_path__ + "static/media/nadjaAlexander.adb32dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/nadjaAlexander.jpg
// module id = 1685
// module chunks = 1